import { ElevenLabsAgent } from '../types';

export const mockAgents: ElevenLabsAgent[] = [
  {
    id: 'agent_9701k1p7krvrecath1wvqz5mv9ar',
    name: 'Allison Thompson - ABA Basics',
    description: 'Analytical mother asking detailed questions about ABA fundamentals',
    personality: 'Detail-oriented healthcare professional who wants evidence-based explanations',
    scenario: 'Initial ABA education consultation',
    guardianId: '1'
  },
  {
    id: 'agent_8k2m9n4p6qrvwxyz1a3b5c7d9e',
    name: 'Allison Thompson - Intake Review',
    description: 'Mother reviewing intake assessment results for Billy',
    personality: 'Engaged parent seeking comprehensive understanding of treatment plan',
    scenario: 'Post-assessment consultation with detailed questions',
    guardianId: '1'
  },
  {
    id: 'agent_5f7h9j1l3nprstvw2x4z6b8d0f',
    name: 'Carlos Rodriguez - Progress Update',
    description: 'Practical father focused on concrete results and next steps',
    personality: 'Solution-focused parent who values efficiency and measurable outcomes',
    scenario: '30-day progress review with emphasis on practical improvements',
    guardianId: '2'
  },
  {
    id: 'agent_3c5e7g9i1kmoqsuw4y6a8c0e2g',
    name: 'Dr. Sarah Chen - Colleague Collaboration',
    description: 'Fellow ABA therapist for professional consultation',
    personality: 'Experienced clinician focused on evidence-based interventions',
    scenario: 'Peer consultation for behavior intervention planning',
    guardianId: null
  }
];